import { encode } from '@toon-format/toon';

/** Browser shim — avoids Node `createRequire` in the client bundle. */
export function encodeValueToToon(value: unknown): string {
  return encode(value);
}
